<template>
  <div class="qa-table">
    <div class="question-row">
      <div class="question-number">Q{{ number }}</div>
      <div class="question-text">{{ question }}</div>
    </div>
    <div class="answer-row">
      <div class="answer-number">A{{ number }}</div>
      <div class="answer-text">{{ answer }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['number', 'question', 'answer'],
}
</script>

<style scoped>
.qa-table {
  width: 80%;
  margin-bottom: 40px;
}

.question-row {
  font-weight: bold;
  line-height: 36px;

  display: flex;

  margin-bottom: 5px;

  color: white;
}

.question-number {
  min-width: 50px;
  margin-right: 5px;

  text-align: center;

  background-color: rgb(26, 87, 167);
}

.question-text {
  line-height: inherit;

  flex-grow: 1;

  padding-left: 20px;
  padding-right: 20px;

  background-color: rgb(26, 161, 230);
}

.answer-row {
  position: relative;

  border: 1px solid rgb(26, 161, 230);
  background-color: rgb(247, 249, 252);
}

.answer-number {
  font-weight: bold;
  line-height: 36px;

  position: absolute;

  width: 50px;

  text-align: center;

  color: white;
  background-color: rgb(26, 161, 230);
}

.answer-text {
  font-size: 14px;

  padding: 20px 20px 20px 70px;

  white-space: pre-line;
}

@media only screen and (max-width: 600px) {
  .qa-table {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/QuestionAndAnswer.vue